import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import api from 'api';

import css from 'css';

import { msg, gtmPush, opportunityErrorMessage } from 'helpers';

import { Input } from 'partials/formElements';
import CheckmarkCircle from 'images/CheckmarkCircle';

import {
    setCheckoutNextCallback,
    setCheckoutCustomer,
    setCheckoutError,
    setTermsVisibility
} from 'store';

const Wrapper = styled.div``

const InputRow = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 30px;
    align-items: center;

    .input-wrapper {
        width: 100%;

        input {
            width: 100%;
            height: auto;
            padding: 15px;
            background: #E3EFFD;
            border: none;
            border-bottom: 4px solid ${css.colors.blue};
        }

        label {
            color: #FFF;
        }

        &.error {
            input {
                border-color: ${css.colors.red};
            }
        }
    }

    svg {
        position: absolute;
        top: 40px;
        right: 15px;
        opacity: 0;
    }

    &.valid {
        .input-wrapper input {
            padding-right: 50px;
        }

        svg {
            opacity: 1;
        }
    }
`

const BottomMessage = styled.div`
    color: #FFF;
    text-align: center;
    margin-bottom: 30px;
`

class InvoicePayment extends Component {
    constructor() {
        super();

        this.state = {
            errors: {
                street: '',
                postalCode: '',
            },
            isValid: {
                street: false,
                postalCode: false,
            },

        }
    }

    componentDidMount() {
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': 'Checkout - Bestilling',
            'pageURI': '/checkout/betaling/faktura', 
        });
    }

    _onInputChange(key, value) {
        this.setState({
            errors: { ...this.state.errors, [key]: '' }
        });

        if (key === 'postalCode') {
            value = value.toString()
                .replace(/[^\d]/g, '')
                .substring(0, 4);
        }

        this.props.setCheckoutCustomer({ ...this.props.customer, [key]: value });
    }

    _validateInput(key) {
        const value = this.props.customer[key];

        if (!value) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('fieldRequired') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        this.setState(state => ({
            errors: { ...state.errors, [key]: '' },
            isValid: { ...state.isValid, [key]: true }
        }));

        return true;
    }

    _onSubmit = () => {
        const { termsAccepted } = this.props.checkout;

        const isValid = !Object.keys(this.state.isValid).filter(key => {
            return !this._validateInput(key);
        }).length;

        if (!isValid && this.props.opportunity.registrationType === 'DEFAULT_CHECKOUT') {
            return false;
        }

        if(!termsAccepted) {
            this.props.setTermsVisibility(true);
            return false;
        }

        let promisList = [];
        if(this.props.opportunity.registrationType === 'SALESFORCE_LINK_CHECKOUT'){
            promisList = [
                this._onOpportunityUpdate()
            ]
        }else{
            promisList = [
                this._onCustomerUpdate(),
                this._onOpportunityUpdate()
            ]
        }

        return Promise.all(promisList).then(() => {
            return this._onTimeSchedualCreation().then(() => {
                return true;
            }).catch(() => {
                return false;
            });
        }).catch(error => {
            this.props.setCheckoutError(opportunityErrorMessage(error, 'unableToUpdatePayment'));

            return false;
        });
    }

    _onCustomerUpdate() {
        const { customer } = this.props;

        const parameters = {
            firstName: customer.firstName ? customer.firstName.trim() : null,
            lastName: customer.lastName ? customer.lastName.trim() : null,
            personalNumber: customer.personalNumber ? customer.personalNumber.trim() : null,
            email: customer.email ? customer.email.trim() : null,
            phone: customer.phone ? customer.phone.trim() : null,
            country: null,
            city: null,
            street: customer.street ? customer.street.trim() : null,
            postalCode: customer.postalCode ? customer.postalCode.trim() : null,
            partialObject: customer.partialObject,
        }

        return api.updateCustomer(customer.id, parameters);
    }

    _onOpportunityUpdate() {
        const { opportunity } = this.props;

        if (!opportunity.id) {
            return Promise.reject(new Error('Missing opportunity id'));
        }

        const parameters = {
            customerId: opportunity.customerId,
            educationalGoal: opportunity.educationalGoal,
            attachments: opportunity.attachments,
            comment: opportunity.comment,
            programs: opportunity.programs,
            courses: opportunity.courses,
            transactionId: null,
            reservedAmount: 0,
            paymentMethod: opportunity.paymentMethod,
            coupon: opportunity.coupon,
            partialObject: opportunity.partialObject,
        }

        return api.updateOpportunity(opportunity.id, parameters);
    }

    _onTimeSchedualCreation() {
        const { autumnSchemaCourseOccasionIds, springSchemaCourseOccasionIds } = this.props.timeSchedule;

        const courseOccasionIds = autumnSchemaCourseOccasionIds.concat(springSchemaCourseOccasionIds);

        const parameters = {
            courseOccasionIds: courseOccasionIds,
            opportunityId: this.props.opportunity.id,
        }

        return api.createTimeScheduler(parameters).then(response => {
            if(response.data.error) setCheckoutError('Noe gikk galt ved lagring av timeplanen');
            return response;
        }).catch(error => {
            return error;
        });
    }

    render() {
        const { errors, isValid } = this.state;
        const { street, postalCode } = this.props.customer;
        const { registrationType } = this.props.opportunity;

        if(registrationType === 'SALESFORCE_LINK_CHECKOUT'){
            return (
                <Wrapper></Wrapper>
            );
        }else{
            return (
                <Wrapper>
                    <InputRow className={isValid.street ? 'valid' : ''}>
                        <Input label="Adresse" value={street || ''} error={errors.street} onChange={e => this._onInputChange('street', e.target.value)} onBlur={() => this._validateInput('street')} />
                        <CheckmarkCircle />
                    </InputRow>
                    <InputRow className={isValid.postalCode ? 'valid' : ''}>
                        <Input label="Postnummer" value={postalCode || ''} error={errors.postalCode} onChange={e => this._onInputChange('postalCode', e.target.value)} onBlur={() => this._validateInput('postalCode')} />
                        <CheckmarkCircle />
                    </InputRow>
                    <BottomMessage>
                        Vi gjør deg oppmerksom på at det blir utført en kredittsjekk av deg ved betaling med faktura.
                    </BottomMessage>
                </Wrapper>
            );
        }
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
    customer: state.customer,
    timeSchedule: state.timeSchedule,
    checkout: state.checkout
});

const actions = {
    setCheckoutNextCallback,
    setCheckoutCustomer,
    setCheckoutError,
    setTermsVisibility
}

export default withRouter(connect(mapStateToProps, actions)(InvoicePayment));


// WEBPACK FOOTER //
// ./src/partials/Checkout/InvoicePayment.js